/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
window.addEventListener("load", async () => {
  const response = await fetch(`${gvvAjax.ajax_url}?action=get_all_teams`);
  if (response.status !== 200) {
    console.error("Error fetching teams:", response.statusText);
    return;
  }
  const result = await response.json();
  const teams = result.data;
  const container = document.querySelector(".wp-block-gvv-teams-submenu");
  const teamsMarkedUp = teams.map((team) => {
    return `<a class="team-item" href="${team.permalink}">
        <img src="/wp-content/themes/gvv-geldermalsen/src/img/pentagon-bullet.svg" alt="pentagon bullet" width="10" class="team-item-bullet" />
        ${team.title}
    </a>`;
  });
  container.innerHTML = teamsMarkedUp.join("");
});
/* eslint-enable no-console */
